import { Routes } from '@angular/router';
import { locationsLoadedGuard } from '../locations/guards/locations-loaded.guard';
import { energyInterfacesLoadedGuard } from './guards/energy-interfaces-loaded.guard';
import { energyInterfaceLoadedGuard } from './guards/energy-interface-loaded.guard';
import { videoTutorialsLoadedGuard } from '../tutorials/guards/video-tutorials-loaded.guard';
import { EnergyInterfacesPage } from './pages/energy-interfaces-page/energy-interfaces-page';
import { EnergyInterfaceDetailsPage } from './pages/energy-interface-details-page/energy-interface-details-page';
import { EnergyInterfaceDetailsGeneralPage } from './pages/energy-interface-details-general-page/energy-interface-details-general-page';
import { EnergyInterfaceDetailsAddressPage } from './pages/energy-interface-details-address-page/energy-interface-details-address-page';
import { roleGuard } from '../../core/guards/role.guard';
import { EnergyInterfaceDetailsLoadCurvePage } from './pages/energy-interface-details-load-curve-page/energy-interface-details-load-curve-page';
import { EnergyInterfaceDetailsConsumptionPage } from './pages/energy-interface-details-consumption-page/energy-interface-details-consumption-page';

export const ENERGY_INTERFACES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [locationsLoadedGuard, energyInterfacesLoadedGuard, videoTutorialsLoadedGuard],
    component: EnergyInterfacesPage,
  },
  {
    path: ':energyInterfaceId',
    canActivate: [energyInterfaceLoadedGuard],
    component: EnergyInterfaceDetailsPage,
    children: [
      {
        path: 'general',
        canActivate: [locationsLoadedGuard],
        component: EnergyInterfaceDetailsGeneralPage,
      },
      {
        path: 'address',
        canActivate: [locationsLoadedGuard, roleGuard('USER_ADMIN')],
        component: EnergyInterfaceDetailsAddressPage,
      },
      {
        path: 'load-curve',
        canActivate: [roleGuard('USER_ADMIN')],
        component: EnergyInterfaceDetailsLoadCurvePage,
      },
      {
        path: 'consumption',
        component: EnergyInterfaceDetailsConsumptionPage,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'general',
      },
    ],
  },
];
